"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_2 = require("swiper/react");
const swiper_1 = require("swiper");
require("swiper/css");
require("swiper/css/autoplay");
require("swiper/css/navigation");
require("swiper/css/pagination");
const api_1 = require("@/api");
const chevron_left_white_circline_svg_1 = __importDefault(require("@@/assets/svgs/chevron_left_white_circline.svg"));
const functions_1 = require("@/common/functions");
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
const _1 = require(".");
function default_1() {
    const [bannerData, setBannerData] = (0, react_1.useState)([]);
    const bannerDataLeng = bannerData.length;
    const isLoopable = bannerDataLeng > 1;
    (0, react_1.useEffect)(() => {
        (0, api_1.getData)('/api/v1/fondee/main-banner')
            .then(res => setBannerData(res.data.result))
            .catch(() => { });
    }, []);
    const maxWidth768 = (0, useMediaQuery_1.default)('(max-width:768px)');
    const navigationOptions = maxWidth768
        ? false
        : { prevEl: '.swiper-navigation-prev', nextEl: '.swiper-navigation-next' };
    const navigationBtnSx = {
        position: 'absolute',
        display: maxWidth768 || !isLoopable ? 'none' : 'flex',
        top: '50%',
        marginTop: '-20px',
        zIndex: 10,
    };
    const paginationOptions = maxWidth768
        ? {
            type: 'fraction',
            renderFraction: (currCls, totalCls) => `<span class="${currCls}"></span>/<span class="${totalCls}"></span>`,
        }
        : { clickable: true };
    const swiperCss = {
        // ? https://github.com/nolimits4web/swiper/issues/3527
        width: '100%',
        '.swiper-wrapper': {
            WebkitTransformStyle: 'preserve-3d',
        },
        '.swiper-slide': {
            display: 'flex',
            WebkitBackfaceVisibility: 'hidden',
            WebkitTransform: 'translateZ(0)',
        },
        '.swiper-pagination-fraction': {
            bottom: '12px',
            right: '16px',
            left: 'unset',
            width: 'unset',
            color: 'white',
            textAlign: 'right',
            fontSize: '12px',
            padding: '4px 10px',
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            borderRadius: '50px',
        },
        '.swiper-pagination-bullets': { bottom: '20px' },
        '.swiper-pagination-bullet': {
            border: '1px solid #fff',
            margin: '0 5px',
            backgroundColor: 'rgba(0, 0, 0, 0.2)',
            opacity: 1,
        },
        '.swiper-pagination-bullet-active': { backgroundColor: '#ee7744' },
    };
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: Boolean(bannerDataLeng) ? ((0, jsx_runtime_1.jsxs)(react_2.Swiper
        // ? key: to force rerender, otherwise it would not change via viewport width changes
        , Object.assign({ modules: [swiper_1.Autoplay, swiper_1.Navigation, swiper_1.Pagination], loop: isLoopable, autoplay: { delay: 5000, disableOnInteraction: false, pauseOnMouseEnter: true }, navigation: navigationOptions, pagination: paginationOptions, speed: 1000, css: swiperCss }, { children: [(0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ className: "swiper-navigation-prev", sx: Object.assign(Object.assign({}, navigationBtnSx), { left: '26px' }) }, { children: (0, jsx_runtime_1.jsx)(chevron_left_white_circline_svg_1.default, {}) })), (0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ className: "swiper-navigation-next", sx: Object.assign(Object.assign({}, navigationBtnSx), { right: '26px' }) }, { children: (0, jsx_runtime_1.jsx)(chevron_left_white_circline_svg_1.default, { css: { transform: 'rotate(180deg)' } }) })), bannerData.map((banner, index) => {
                    const { banner_type, img_url, notice_id, room_id, category, title } = banner;
                    const generatedKey = `main_banner_${notice_id || room_id}_${index}`;
                    const onBannerClick = () => {
                        const bannerTypeIsNotice = banner_type === 1;
                        const bannerTypeIsAd = category == '5';
                        const { isNativeApp } = window;
                        if (!bannerTypeIsAd) {
                            const url = `${bannerTypeIsNotice ? '/fondee/notice/?noticeId=' : '/room/room_view/?room_id='}` + `${bannerTypeIsNotice ? notice_id : room_id}`;
                            window.location.href = url;
                        }
                        else {
                            if (isNativeApp) {
                                window.location.href = title;
                            }
                            else {
                                window.open(title);
                            }
                        }
                    };
                    return ((0, jsx_runtime_1.jsx)(react_2.SwiperSlide, { children: (0, jsx_runtime_1.jsx)("img", { src: (0, functions_1.getCdnUrl)(img_url), css: {
                                aspectRatio: maxWidth768 ? '207 / 80' : '5 / 2',
                                width: '100%',
                                objectFit: 'cover',
                                cursor: 'pointer',
                            }, onClick: onBannerClick }) }, generatedKey));
                })] }), `main_banner_max_width_768_${maxWidth768}`)) : ((0, jsx_runtime_1.jsx)(_1.MainBannerSkeleton, {})) }));
}
exports.default = default_1;
